<template>
    <div class="mt-1">
        <!-- <b-row>
            <b-col>
                <h4 class="ml-4 mr-5" v-if="isAlternative">Selected product</h4>
            </b-col>
            <b-col>
                <h4 v-if="isAlternative">Alternative products</h4>
            </b-col>
        </b-row>-->

        <div
            v-bind:key="productChunk.transportProductId"
            v-for="(productChunk) in products"
        >
            <b-row
                class="card-deck"
                v-if="
                    (getShippingOptions.products !== undefined &&
                        getShippingOptions.products.length > 0) ||
                        (getShippingOptions.quoteProducts !== undefined &&
                            getShippingOptions.quoteProducts.length > 0) && 
                             getShippingOptions.errors.length == 0
                "
            >
                <shippingOptionsCard
                    v-bind:key="item.salesProductId + item.transportProductApiId"
                    v-for="(item, index) in productChunk"
                    @create-shipment="$emit('create-shipment', $event)"
                    @create-prebooking="$emit('create-prebooking', $event)"
                    @display-request-quote="$emit('display-request-quote', $event)"
                    @show-alternatives="$emit('show-alternatives', item)"
                    @show-aes="$emit('show-aes', $event)"
                    :item="item"
                    :index="index"
                    :isAlternative="isAlternative"
                    :get-shipment-price="getShipmentPrice"
                ></shippingOptionsCard>
            </b-row>
        </div>
    </div>
</template>
<script>
  import { mapState, mapGetters } from 'vuex';
  import shippingOptionsCard from './shippingOptionsCard';
  import helpers from '../helper';

  export default {
      components: {
          shippingOptionsCard,
      },
      props: {
          getShipmentPrice: { type: Function, required: true },
          products: { type: Array, required: true },
          isAlternative: { type: Boolean, default: false },
      },

      computed: {
          ...mapGetters('createShipment', ['getShippingOptions']),
      },
  };
</script>

<style>
</style>
